<ng-container *transloco="let t">
  <form
    class="ppe-report-dialog flex flex-col gap-3"
    [formGroup]="form"
    [dir]="isRtl ? 'rtl' : 'ltr'"
    (ngSubmit)="submit()"
  >
    <h1 mat-dialog-title class="ppe-report-dialog__title flex flex-row items-center gap-2">
      <span
        class="flex flex-row items-center justify-center rounded-full h-10 w-10 shrink-0 bg-warn-100 dark:bg-warn-900"
      >
        <mat-icon class="icon-size-5" color="warn" aria-hidden="true">report</mat-icon>
      </span>
      <span class="text-primary">{{ t('ppe.ai.report.title') }}</span>
    </h1>

    <div mat-dialog-content class="ppe-report-dialog__body flex flex-col gap-3">
      <p class="text-secondary">{{ t('ppe.ai.report.message') }}</p>

      <label id="ppeReportReasonLabel" class="font-medium">{{
        t('ppe.ai.report.reason_label')
      }}</label>
      <mat-radio-group
        class="ppe-report-dialog__reasons flex flex-col gap-2"
        formControlName="reason"
        aria-labelledby="ppeReportReasonLabel"
      >
        <mat-radio-button
          *ngFor="let reason of reasons"
          class="ppe-report-dialog__reason"
          color="primary"
          [value]="reason"
          [attr.data-reason]="reason"
        >
          {{ t(reasonLabels[reason]) }}
        </mat-radio-button>
      </mat-radio-group>

      <mat-form-field class="ppe-report-dialog__justification w-full" appearance="outline">
        <mat-label>{{
          t(isOther ? 'ppe.ai.report.justification_required' : 'ppe.ai.report.justification')
        }}</mat-label>
        <textarea
          matInput
          formControlName="justification"
          rows="3"
          [attr.maxlength]="maxLength"
          [placeholder]="t('ppe.ai.report.justification_placeholder')"
        ></textarea>
        <mat-hint align="end">{{ justificationLength }} / {{ maxLength }}</mat-hint>
      </mat-form-field>
      <div *ngIf="showJustificationRequired" class="ppe-report-dialog__error text-warn text-sm">
        {{ t('ppe.ai.report.justification_required_error') }}
      </div>
    </div>

    <div mat-dialog-actions class="flex flex-row flex-wrap justify-end gap-2">
      <button type="button" mat-stroked-button class="ppe-report-dialog__cancel" (click)="cancel()">
        {{ t('ppe.ai.report.cancel') }}
      </button>
      <button
        type="submit"
        mat-flat-button
        color="warn"
        class="ppe-report-dialog__submit"
        [disabled]="!canSubmit"
      >
        {{ t('ppe.ai.report.submit') }}
      </button>
    </div>
  </form>
</ng-container>
